import { differencePolygons as s } from "./index3.js";
const a = (n, t) => {
  const e = (r) => r.map((o) => [o[0], 0, o[1]]);
  return s(e(n), t.map(e)).map((r) => r.map((o) => [o[0], o[2]]));
};
export {
  a as differencePolygons2D
};
//# sourceMappingURL=index2.js.map
